<script setup lang="ts">
import type { NuxtLinkProps } from '#app'

defineProps<{
  text: string
  linkLabel: string
  linkTo: NuxtLinkProps['to']
}>()
</script>

<template>
  <NuxtLink :to="linkTo" class="group flex w-full flex-col gap-legacy-m rounded-md bg-seagreen-50 px-legacy-l py-legacy-m no-underline transition-colors duration-300 hover:bg-seagreen-40 md:flex-row">
    <div class="flex flex-col justify-between gap-legacy-xs">
      <p class="font-headline text-2xl leading-9 text-white" v-text="text" />

      <div class="flex items-center gap-legacy-s py-legacy-xs text-base leading-6 font-semibold text-yellow-legacy-20 no-underline">
        {{ linkLabel }}

        <UIcon name="fal:arrow-right-long" class="transition-transform duration-300 group-hover:translate-x-4" />
      </div>
    </div>

    <StaticAsset
      folder="graphics"
      file="packet-shapes.svg"
      class="translate-y-legacy-m px-[37px] sm:px-[130px]"
    />
  </NuxtLink>
</template>
